import axios from 'axios';
import moment from "moment";

export default {

    methods: {
        //fileUpload
        getImage(event) {
             this.fileName = event.target.files[0].name;
             this.locationFile = event.target.value;
            var reader = new FileReader();
            reader.onload = () => {
              this.SingleImage.Image = reader.result;
            };
             reader.readAsDataURL(event.target.files[0]);
          },

        paymentReceivedClick(what) {
            const valueAmount = this.aSinglePaymentReceived.amount;

            if (what == "cheque") {
                if (this.aSinglePaymentReceived.tdNumber == "") {
                    this.showErrorToast("Cheque Number is require");
                    event.preventDefault();
                    return;
                }
                if (this.aSinglePaymentReceived.tdNumber.length < 19) {
                    this.showErrorToast("Card Number length must be 16");
                    return;
                }
                if (this.aSinglePaymentReceived.holderName == 0) {
                    this.showErrorToast("Holder name is require");
                    return;
                }
                if (this.aSinglePaymentReceived.comment == 0) {
                    this.showErrorToast("comment is require");
                    return;
                }
                if (valueAmount == 0) {
                    this.showErrorToast("Amount is require");
                    return;
                }
                if (valueAmount < 0) {
                    this.showErrorToast("Invalid Amount");
                    return;
                }
            }
            if (what == "cash") {
                if (this.aSinglePaymentReceived.amount == 0) {
                    this.showErrorToast("Amount is require");
                    return;
                }
                if (valueAmount == 0) {
                    this.showErrorToast("Amount is require");
                    return;
                }
                if (valueAmount < 0) {
                    this.showErrorToast("Invalid Amount");
                    return;
                }
            } else if (what == "credit-card") {
                if (this.aSinglePaymentReceived.cardCVC == "") {
                    this.showErrorToast("Card CVC is require");
                    return;
                }
                if (this.aSinglePaymentReceived.cardCVC.length < 3) {
                    this.showErrorToast("Card CVC must be of 3 length");
                    return;
                }
                if (this.aSinglePaymentReceived.comment == "") {
                    this.showErrorToast("Comment is require");
                    return;
                }
                if (this.aSinglePaymentReceived.zip == "") {
                    this.showErrorToast("Zip is require");
                    return;
                }
                if (this.aSinglePaymentReceived.cardCVC.length < 3) {
                    this.showErrorToast("Zip must be of 3 length");
                    return;
                }
                if (this.aSinglePaymentReceived.tdNumber == "") {
                    this.showErrorToast("Card Number is require");
                    return;
                }
                if (this.aSinglePaymentReceived.tdNumber.length < 19) {
                    this.showErrorToast("Card Number length must be 16");
                    return;
                }
                if (this.aSinglePaymentReceived.holderName == "") {
                    this.ShowWarning("Holder Name is require");
                    return;
                }
                if (valueAmount < 0) {
                    this.showErrorToast("Invalid Amount");
                    return;
                }
            }
            this.aSinglePaymentReceived.paymentMethod = what;
            this.aSinglePaymentReceived.visitId = this.pat.visitId;
            this.aSinglePaymentReceived.patientId = this.pat.patientId;
            this.aSinglePaymentReceived.pndx = this.pat.pndx;

            this.intDummyComm();
            const url = this.SERVER + "/VNSPRAAPI/Trackers/SavPayRec";
            this.dummyComm.myDate = this.dateToSqlServerDateFormat(new Date());
            const myData = { dc: this.dummyComm, pr: this.aSinglePaymentReceived };

            this.axiosGetData(url, myData).then(res => {
                //console.log("HHHHHHH", res);
                if (res == "err" || res.dc.auditFlag < 0) {
                    this.showErrorToast('Unable to save. ' + res.dc.auditFlagVal);
                } else {
                    this.showSuccessToast('Data saved successfully.');
                }
            });
        },

        tabChange(e) {
            if (this.activeIndex == e.index) return;
            this.activeIndex = e.index;

            if (this.activeIndex === 0) this.paymentMode = "credit-card";
            if (this.activeIndex === 1) this.paymentMode = "cash";
            if (this.activeIndex === 2) this.paymentMode = "cheque";
        },

        savePaymentRequest(){
           //debugger
            var valueAmount = this.aSingleRequestPayment.amount;
            if (this.aSingleRequestPayment.phone == "") {
              this.showErrorToast("Phone is require");
              return;
            }
            if (this.aSingleRequestPayment.phone.length < 12) {
              this.showErrorToast("Phone length must be 10");
              return;
            }
            if (this.aSingleRequestPayment.email == "") {
              this.showErrorToast("Email is require");
              return;
            }
            if (valueAmount == 0) {
                this.showErrorToast("Enter Amount");
                return;
              }
            if (valueAmount < 0) {
              this.showErrorToast("Invalid Amount");
              return;
            }
            if (this.aSingleRequestPayment.email != null) {
              if (!this.validEmail(this.aSingleRequestPayment.email)) {
                this.Validity(this.e);
              }
            }

            //set type_ImageFile
            if(typeof this.SingleImage.Image !== "undefined"){
            var str = this.SingleImage.Image;
            str = str.substring(22);
            if (str.charAt(0) == ",") {
              str = str.substring(1);
            }
            this.aSingleRequestPayment.file = str;
        }

            this.intDummyComm();
            this.dummyComm.visitId = this.pat.visitId;
            this.dummyComm.patientId = this.pat.patientId;

            const myData = {
                dc: this.dummyComm,
                pr: this.aSingleRequestPayment,
              };
              var loader =this.$loading.show({
                // Optional parameters
                  color: '#03a9f3'
                });
            let url = this.SERVER + "/VNSPRAAPI/Trackers/SavPayReq1";
            this.axiosGetData(url, myData).then(res => {
                if (res == "err") {
                    loader.hide();
                    this.ShowWarning("Unable to save Request");
            } else {
              loader.hide();
              this.ShowSuccess("Request Send Successfully.");              
              $(".dropify-clear").trigger("click");
              this.aSingleRequestPayment.amount = "";
              this.aSingleRequestPayment.comment='';
            }
        });
    },

        getPatientBasicInfo() {
            this.intDummyComm();
            this.dummyComm.visitId = this.p_visitId;
            let url = this.SERVER + "/VNSPRAAPI/DropdownModal/GetPatientBasicInfo";
            this.axiosGetData(url, this.dummyComm).then(res => {
                if (res == "err") {
                    this.pat = "";
                } else {
                   //debugger
                    this.pat = res;
                    this.patientName = this.pat.firstName + ' ' + this.pat.lastName;
                    this.patDOB = moment(String(this.pat.dob)).format("MM/DD/YYYY");
                    this.patDOS = this.pat.dos.split("T")[0];
                    this.aSingleRequestPayment.phone = this.pat.phone;
                    this.aSingleRequestPayment.email = this.pat.email;
                    this.patDOS = moment(String(this.patDOS)).format("MM/DD/YYYY");
                }
            });
        },

        //-------------------- Common Methods
        async axiosGetData(myUrl, myData) {
            let data = "err";
            await axios({
                method: "post",
                url: myUrl,
                data: myData,
                contentType: "application/json",
                dataType: "json",
                headers:{
                    Authorization: this.$store.getters.getAuthToken,
                  }
            })
                .then((res) => {
                    data = res.data;
                })
                .catch(function (err) { console.log(err); })
                .finally(() => { });

            return data;
        }, // axiosGetData
    }, // methods


    watch: {

    }, // watch

    mounted() {
        //ImageDropfy
        $('.dropify').dropify();
        this.img = this.$refs.myimage;

        this.paymentMode = "credit-card";
        this.getPatientBasicInfo();
        this.showThisModel = true;
    },


}

